<template>
    <div>
        <!-- <base-button icon type="primary" class="float-right" @click="printDocument">
            <i class="fa fa-print"></i>Print
        </base-button> -->
        <b-button icon @click="printDocument" class="transparent-btn">
            <i class="fa fa-print mr-2 text-success"></i>{{language_terms['PRINT']}}
        </b-button>
    </div>
</template>
<script>
// Import PDF Make components
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { mapState } from "vuex";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Roboto": 
        {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            // italics: 'Roboto-Italic.ttf',
            // bolditalics: 'Roboto-MediumItalic.ttf'
        }
};

export default{
    name:'printDocument',
    data(){
        return{
            font:'Roboto'
        }
    },
    props:
    {
        data:{
            type:Object,
            required: true,
            default: function () { return {} },
        }
    },
    computed: {
        ...mapState({
            language_terms: (state) => state.languages.language_terms,
            selected_lang: (state) => state.languages.selected_langauge,
        })
    },
    mounted()
    {
    },
    methods:
    {
        capitalizeFirstLetter(string) {
            if(string)
            {
                let str = string.toLowerCase();
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
            else
            {
                return string
            }
        },
        uploadGeneratedPdf(document_data, document_name, document_type, document_id)
        {
            let document = this.data
            const pdfDocGenerator = pdfMake.createPdf(document_data);
            let apiPdfUpload = null;

            if(document_type == 'SQ')
                apiPdfUpload = apiRoutes['UPLOAD_SQ'];
            else if(document_type == 'SO')
                apiPdfUpload = apiRoutes['UPLOAD_SO'];
            else if(document_type == 'SI')
                apiPdfUpload = apiRoutes['UPLOAD_SI'];

            pdfDocGenerator.getBase64((data)=>{
                var contentType = 'image/png';
                var b64Data = data;
                var blob = this.b64toBlob(b64Data, contentType);

                var blobUrl = URL.createObjectURL(blob);
                var file_name = document_name+ '.pdf'
                this.urltoFile(blobUrl, file_name, 'application/pdf').then(function(file)
                {
                    let formData = new FormData();
                    //element.loading = true
                    var docType = document_name
                    formData.append(docType, file);
                    axios.post(apiPdfUpload, formData, authHeader()).then(res => {
                        if(res.data.code == 1)
                        {
                            var upload_id = res.data.msg
                            let payload = {"id": upload_id, "document_id": document_id, "data_json": document, "revision_id":document.revision_id}
                            axios.post(apiRoutes['UPDATE_DOCUMENT_PRINTOUTS'], payload,authHeader())
                            .then(response =>
                                {
                                    var data = response.data
                                    if(data.code == 1)
                                    {
                                    }
                                })
                        }
                        else
                        {
                            this.errorMessage = res.data.msg
                            alert(this.errorMessage)
                        }
                    })
                    .catch(function(){console.log('FAILURE!!');});
                })
            });
        },
        b64toBlob(b64Data, contentType, sliceSize)
        {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) 
            {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) 
                {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {type: contentType});

            return blob;
        },
        urltoFile(url, filename, mimeType)
        {
            return (fetch(url)
                .then(function(res){return res.arrayBuffer();})
                .then(function(buf){return new File([buf], filename, {type:mimeType});})
            );
        },
        async printDocument()
        {
            let font = 'ukai'
            if(this.selected_lang == 'en') 
            {
                font = 'Roboto'
            }
            else
            {
                font = 'ukai'
            }
            let document_title = this.data.code
            let slae_document_type = (this.data.type == 'SQ') ? this.language_terms['SALE_QUOTATION'] : ((this.data.type == 'SO') ? this.language_terms['SALE_ORDER'] : this.language_terms['SALE_INVOICE'])

            let document_items = []
            let document_items_headers = [
                
                {
                    text: this.language_terms['NO.'],
                    style: 'itemsHeader',
                    alignment: 'center'
                },
                {
                    text: this.language_terms['DESCRIPTION'],
                    style: 'itemsHeader',
                    alignment: 'left'
                },
                {
                    text: this.language_terms['QTY'],
                    style: 'itemsHeader',
                    alignment: 'center'
                },
                
                {
                    text: this.language_terms['LIST_PRICE'],
                    style: 'itemsHeader',
                    alignment: 'center'
                },
                {
                    text: this.language_terms['UNIT_PRICE'],
                    style: 'itemsHeader',
                    alignment: 'center'
                },
                {
                    text: this.language_terms['AMOUNT'],
                    style: 'itemsHeader',
                    alignment: 'center'
                },
            ]
            document_items.push(document_items_headers)

            for (let key in this.data.items)
            {
                var data = this.data.items[key]
                let row = [
                        {
                            text: (key * 1) + 1,
                            style: 'itemText',
                            alignment: 'center'
                        },
                        {
                            text: data.product_code + '\r\n' + data.product_name,
                            style: 'itemText'
                        },
                        {
                            text: parseInt(data.qty * 1) + data.uom,
                            style: 'itemNumber',
                            alignment:'center'
                        },
                        {
                            text: (data.sale_list_price * 1).toFixed(2),
                            style: 'itemNumber'
                        },
                        {
                            text: (data.unit_price * 1).toFixed(2),
                            style: 'itemNumber'
                        },
                        {
                            text: (data.gross_amount * 1).toFixed(2),
                            style: 'itemNumber'
                        }
                ]
                document_items.push(row)
            }

          
            var ddHeader = {
                columns: [
                    [
                        {
                            stack: 
                            [
                                {
                                    columns: 
                                    [ 
                                        {
                                            image:"data:image/png;base64,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"
                                            ,fit: [130, 130],
                                            //[left, top, right, bottom]
                                            margin: [0,0,100,0],
                                            alignment:'left'
                                        },
                                        {
                                            text: slae_document_type, 
                                            style: 'invoiceTitle',
                                            width: '*',
                                            alignment:'right'
                                        },
                                        {
                                            qr:data.code,
                                            fit: '50',                         
                                            alignment:'left'
                                        },
                                    ]
                                },
                                {
                                    text:"Address: 15 Fourth Lok Yang Rd, Singapore 629711",
                                    style: 'invoiceSubValue',
                                    margin: [0,0,0,5],
                                },
                                {
                                    text:"Telephone: +65 6855 0770",
                                    style: 'invoiceSubValue',
                                    margin: [0,0,0,5],
                                },
                                {
                                    text:"UEN: 199307700K",
                                    style: 'invoiceSubValue',
                                    margin: [0,0,0,5],
                                }
                            ],
                            
                        },
                        {
                            margin:[0,20,0,0],
                            // /[left, top, right, bottom]
                            stack: [
                            {
                                margin:[0,0,0,3],
                                columns: [
                                    {
                                        text: this.language_terms['SEND_TO'] + ' :',
                                        style: 'invoiceSubTitle',
                                        width: 90
                                    },
                                    {
                                        text: this.data.contact_name,
                                        style: 'invoiceSubValue',
                                        width: 200,

                                    },
                                    {
                                        text: this.language_terms['SALESPERSON'] + ' :',
                                        style: 'invoiceSubTitle',
                                        width: 90

                                    },
                                    {
                                        text: this.data.salesperson_contact_name,
                                        style: 'invoiceSubValue',
                                        width: '*',
                                    },
                                    
                                ]
                            },
                            {
                                margin:[0,0,0,3],
                                columns: [
                                    {
                                        text: this.language_terms['ADDRESS'] + " :",
                                        style: 'invoiceSubTitle',
                                        width: 90
                                    },
                                    {
                                        text: this.data.address ? this.data.address.trim()  : this.data.address,
                                        style: 'invoiceSubValue',
                                        width: 200
                                    },
                                    {
                                        text: this.language_terms['MOBILE'] + " :",
                                        style: 'invoiceSubTitle',
                                        width: 90
                                    },
                                    {
                                        text: this.data.salesperson_contact_mobile,
                                        style: 'invoiceSubValue',
                                        width: '*',
                                    },
                                ]
                            },
                            {
                                margin:[0,0,0,3],
                                columns: [
                                    {
                                        text: this.language_terms['ATTENTION'] + " :",
                                        style: 'invoiceSubTitle',
                                        width: 90

                                    },
                                    {
                                        text: this.data.attention_to,
                                        style: 'invoiceSubValue',
                                        width: '*',

                                    },
                                    // {
                                    //     text: this.language_terms['TAX_CODE'],
                                    //     style: 'invoiceSubTitle',
                                    //     width: 90

                                    // },
                                    // {
                                    //     text: this.data.tax_code,
                                    //     style: 'invoiceSubValue',
                                    //     width: '*',

                                    // }
                                ]
                            }
                        ]
                    }],
                ],
            }
            var dd = {
                header: function()
                {
                    
                    return {
                        margin: [0, 20, 0, 0],
                        columns: [
                        {
                            text: '',
                            style: 'documentHeaderLeft'
                        },
                        {
                            text: document_title,
                            style: 'documentHeaderCenter'
                        },
                        {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    }
                },
                footer: function(pageNumber, pageCount)
                {
                    return {
                        margin: [0, 0, 0, 30],
                        columns: [
                        {
                            text: '',
                            style: 'documentFooterLeft'
                        },
                        {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        },
                        {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                // [left, top, right, bottom]
                content: [
                    ddHeader,
                    // Line breaks
                    '\n\n',
                    {
                        layout: 'lightHorizontalLines',
                        table:
                        {
                            dontBreakRows: true,
                            headerRows: 1,
                            widths: [25, '*', 60, 65, 65, 65],
                            body: document_items
                        }, // table
                    },
                    { 
                        text: '________________________________________________',
                        style:'notesText',
                        alignment: 'right'
                    },
                    {
                        table: {
                            headerRows: 0,
                            widths: [ '*', 100 ],
                            body: 
                            [
                                [ 
                                    {
                                        text:this.language_terms['SUB_TOTAL'] +  " " + this.data.currency_code  + ':',
                                        style:'itemsFooterTotalTitle',
                                        alignment: 'right'
                                    }, 
                                    {
                                        text: this.data.gross_amount,
                                        style:'itemsFooterSubTotalValue',
                                        alignment: 'right'
                                    }
                                ],
                            ]
                        }, // table
                        layout: 'lightHorizontalLines'
                    },
                    // { 
                    //     text: '________________________________________________',
                    //     style:'notesText',
                    //     alignment: 'right',
                    //     margin:[0,0,0,0]
                    // },
                    {
                        table: {
                            headerRows: 0,
                            widths: [ '*', 100 ],
                            body: 
                            [
                                [ 
                                    {
                                        text:this.language_terms['TAX_AMOUNT'] + " " + this.data.currency_code + ':',
                                        style:'itemsFooterTotalTitle',
                                        alignment: 'right'
                                    }, 
                                    {
                                        text: this.data.tax_amount,
                                        style:'itemsFooterSubTotalValue',
                                        alignment: 'right'
                                    }
                                ],
                            ]
                        }, // table
                        layout: 'lightHorizontalLines'
                    },
                    { 
                        text: '________________________________________________',
                        style:'notesText',
                        alignment: 'right',
                        //[left, top, right, bottom]
                        margin:[0,0,0,0]
                    },
                    {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            // Total  
                            headerRows: 0,
                            widths: [ '*', 100 ],
                            body: 
                            [
                                [ 
                                    {
                                        text:'Total ' + this.data.currency_code + ' :',
                                        style:'itemsFooterTotalTitle',
                                        alignment: 'right'
                                    }, 
                                    {
                                        text: this.data.nett_amount,
                                        style:'itemsFooterTotalValue',
                                        alignment: 'right'
                                    }
                                ],
                            ]
                        }, // table
                        layout: 'lightHorizontalLines'
                    },
                    { 
                        text: '________________________________________________',
                        style:'notesText',
                        alignment: 'right',
                        margin:[0,-10,0,-5]
                    },
                                        { 
                        text: '________________________________________________',
                        style:'notesText',
                        alignment: 'right',
                        margin:[0,0,0,0]
                    },
                    {
                        //pageBreak:'before',
                        columns: [
                                    {
                                        stack: [
                                            { 
                                                text: this.language_terms['TERMS_AND_CONDITIONS'],
                                                style:'signaturePlaceholder',
                                                bold:true
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100,  '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['DELIVERY'] ,
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text: ': ' + (this.data.delivery_eta_days ? this.data.delivery_eta_days : '(-)') + ' ' + this.language_terms['WORKING_DAY'],
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 10, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100,  '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['PRICE'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text: ': ' + this.data.currency_code,
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100,  '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['PAYMENT'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text: ': ' + 'COD',
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100,  '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['VALIDITY'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text:  ': ' + this.data.due_days + " " + this.language_terms['DAYS'],
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100, '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['OUR_BANK'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text:  ': ' + "UNITED OVERSEAS BANK LTD",
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100, '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['ACCOUNT_NUMBER'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text: ': ' + "913-344-743-8",
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100, '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['BANK_CODE'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text: ': ' + "7375 SWIFT CODE: UOVBSGSG",
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                table: {
                                                    // headers are automatically repeated if the table spans over multiple pages
                                                    // you can declare how many rows should be treated as headers
                                                    // Total  
                                                    headerRows: 0,
                                                    widths: [ 100, '*' ],
                                                    body: 
                                                    [
                                                        [ 
                                                            {
                                                                text: this.language_terms['PAYNOW_UEN'],
                                                                style:'itemsFooterTotalTitle',
                                                                alignment: 'left'
                                                            }, 
                                                            {
                                                                text: ': ' + "199307700K",
                                                                style:'itemsFooterTotalValue',
                                                                alignment: 'left'
                                                            }
                                                        ],
                                                    ]
                                                }, // table
                                                layout: 'lightHorizontalLines',
                                                margin: [0, 0, 0, -8],
                                            },
                                            {
                                                text:"Please Email/Fax Your P/O to us.",
                                                style:'footerReminder',
                                            },
                                            {
                                                text:"All sales transcated are subject to our company's",
                                                style:'footerReminder',
                                                margin:[0,10,0,0]
                                            },
                                            {
                                                text:"Standard Terms and Conditions of Sales",
                                                style:'footerReminder',
                                                margin:[0,0,0, 12]
                                            },
                                            {
                                                text:"Yours faithfully,",
                                                style:'greetingTxt',
                                                margin:[0,0,0, 0]
                                            },
                                            {
                                                text:this.data.salesperson_contact_name,
                                                style:'greetingTxt',
                                                margin:[0,2,0, 2]
                                            },
                                            {
                                                text:'ES-TEAM LIGHTING PTE LTD',
                                                style:'footerReminder',
                                                margin:[0,0,0, 10]
                                            },
                                            // { 
                                            //     text: '___________________________',
                                            //     style:'signaturePlaceholder'
                                            // },
                                            // { 
                                            //     text: this.language_terms['NAME'] + '  : ',
                                            //     style:'signatureName'
                                                
                                            // },
                                            // { 
                                            //     text: this.language_terms['DATE'] + '  : ' + this.data.date,
                                            //     style:'signatureJobTitle'
                                                
                                            // }
                                            ],
                                            width: '*'
                                    }, 
                                    // {
                                    //     stack: [
                                    //         { 
                                    //             text: '  ',
                                    //             style:'signaturePlaceholder'
                                    //         },

                                    //         { 
                                    //             text: '                      ',
                                    //             style:'signaturePlaceholder'
                                    //         },
                                    //         { 
                                    //             text: '  ',
                                    //             style:'signatureName'
                                                
                                    //         },
                                    //         { 
                                    //             text: '      ',
                                    //             style:'signatureJobTitle'
                                                
                                    //         }
                                    //         ],
                                    //         width: 180
                                    // }, 
                                    // {
                                    //     stack: [
                                    //         { 
                                    //             text: this.language_terms['APPROVED_BY'],
                                    //             style:'signaturePlaceholder'
                                    //         },

                                    //         { 
                                    //             text: '___________________________',
                                    //             style:'signaturePlaceholder'
                                    //         },
                                    //         { 
                                    //             text: this.language_terms['NAME'] + '  :',
                                    //             style:'signatureName'
                                                
                                    //         },
                                    //         { 
                                    //             text: this.language_terms['DATE'] + '  :',
                                    //             style:'signatureJobTitle'
                                    //         }
                                    //         ],
                                    //         width: 160
                                    // }

                                ]
                    }

                ],
                styles:
                {
                    // Document Header
                    documentHeaderLeft:
                    {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter:
                    {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight:
                    {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },
                    // Document Footer
                    documentFooterLeft:
                    {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter:
                    {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight:
                    {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },
                    // Invoice Title
                    invoiceTitle:
                    {
                        fontSize: 17,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 10]
                    },
                    // Invoice Details
                    invoiceSubTitle:
                    {
                        fontSize: 10,
                        bold: true,
                        alignment: 'left',
                    },
                    invoiceSubValue:
                    {
                        fontSize: 10,
                        alignment: 'left',
                    },
                    // Billing Headers
                    invoiceBillingTitle:
                    {
                        fontSize: 11,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5],
                    },
                    // Billing Details
                    invoiceBillingDetails:
                    {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle:
                    {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress:
                    {

                    },
                    // Items Header
                    itemsHeader:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        fillColor:'#548DD4',
                        color: '#fff',

                    },
                    // Item Title
                    itemTitle:
                    {
                        bold: true,
                    },
                    itemSubTitle:
                    {
                        fontSize: 10
                    },
                    itemText:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left',
                    },
                    itemNumber:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right',
                    },
                    itemTotal:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },

                    itemsFooterSubTitle:
                    {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },
                    itemsFooterSubValue:
                    {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center',
                    },
                    greetingTxt:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left',
                    },
                    footerReminder:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'left',
                    },
                    itemsFooterTotalTitle:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right',
                    },
                    itemsFooterSubTotalValue:
                    {
                        fontSize: 10,
                        margin: [0, 0, 0, 0],
                        //bold: true,
                        alignment: 'center',
                    },
                    itemsFooterTotalValue:
                    {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center',
                    },
                    signaturePlaceholder:
                    {
                        fontSize: 11,
                        margin: [0, 70, 0, 0],
                    },
                    signatureName:
                    {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left',
                    },
                    signatureJobTitle:
                    {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        //bold: true,
                        //font:'ukai',
                        alignment: 'left',
                    },
                    notesTitle:
                    {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 50, 0, 3],
                    },
                    notesText:
                    {
                        fontSize: 10
                    },
                    center:
                    {
                        alignment: 'center',
                    },
                },
                defaultStyle:
                {
                    columnGap: 20,
                    font: font
                }
            }

            await this.uploadGeneratedPdf(dd, this.data.code, this.data.type, this.data.id);

            pdfMake.createPdf(dd).open();

        }
    }

}

</script>
